import React, {useContext, useEffect, useState} from 'react'
// import { css } from '@emotion/react'
import styled from '@emotion/styled'
import scrollToElement from 'scroll-to-element'


// Components
import SEO from '../components/seo'
import Layout from '../components/layout'
import Container from '../components/container'
import Project from '../components/project'


import ObserverTop from '../utils/observerTopAbout'
import ObserverBottom from '../utils/observerBottomAbout'


// Context
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '../context/globalContextProvider'

import theme from '../utils/theme';
import {CommonTextStyles} from '../utils/styles'
import { globalHistory as history } from '@reach/router'



const PageWrap = styled('div')`
  //padding-top: 60px;
  //padding-bottom: 140px;

  @media ${theme.breakpoints.md} { 
    //padding-top: 80px;
    //padding-bottom: 160px
    //max-width: 83%;
  }
`

const Section = styled('div')`
  ${CommonTextStyles};
  overflow: hidden;

  position: relative;
  border-top: 1px solid #E6E6E6;
  padding-top: 60px;
  padding-bottom: 100px;
  padding-right: 15px;
  padding-left: 15px;

  &:first-of-type {
    //padding-top: 30px;
    border-top: none;
  }

  h2 {
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  p {
    margin-top: 1em;
    margin-bottom: 0;
  }

  &.contact {
    //min-height: calc(100vh + 2px);
    min-height: calc(var(--real100vh) + 2px);
    padding-bottom: 25px;
    display: flex;
    flex-direction: column;
  }

  @media ${theme.breakpoints.lg} { 
    padding-top: 120px;
    padding-bottom: 160px;
    padding-right: 20px;
    padding-left: 20px;

    /*
    &:first-of-type {
      padding-top: 70px;
    }
    */

    > div {
      max-width: 83%;
    }

    &.contact {
      //min-height: calc(100vh + 2px);
      min-height: calc(var(--real100vh) + 2px);
      padding-bottom: 25px;
    }
  }
`

const Credits = styled('div')`
  display: flex;
  align-items: flex-end;
  
  margin-top: auto;
  height: 155px;
  
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0;

  @media ${theme.breakpoints.lg} { 
    height: 180px;
  }
`




/*
 * Component
 */
const AboutPage = (props) => {
  
  const {
    removeIntro,
    setHideStatusContainer,
    setIsCurrent,
    isCurrent,
    setCurrentProject,
    setFieldNotes,
    setSection,
    setRef,
  } = props.pageProps || props // props.pageProps is fed from router in index.js


  const state = useContext(GlobalStateContext) || {}
  const dispatch = useContext(GlobalDispatchContext)
  useEffect(() => {
    dispatch({ 
      type: 'setTheme',
      value: 'white',
    })
  }, []);


  const { location, navigate } = history


  useEffect(() => {
    setSection(location.pathname)
  }, []);


  // Hide Status Container on page load
  useEffect(() => {
    setHideStatusContainer(false)
    setCurrentProject(null)
    setFieldNotes(null)

    return () => {
      setHideStatusContainer(true)
    }
  }, []);


  return (
    <>
      <SEO
        title='About'
      />
      <PageWrap>
        <Section id="biography" ref={setRef('biography')}>
          <div>
            <ObserverTop title="Biography" setIsCurrent={setIsCurrent} isFirst={true} />
            <h2>Biography</h2>
            <p>Jens Assur is a Swedish photographer, artist and director, critically acclaimed for his work as a photojournalist but also as an artist with solo exhibitions at the major art venues in Sweden. Except from photographic projects Assur has also written, directed and produced five feature films. They have all been selected to the world’s leading film festivals like Cannes, Sundance, Tribeca, Toronto among others and received Grand Prix in a few of them as well.</p>
            <p>In the nineties, Assur started working as a photographer for the largest Swedish daily newspaper, Expressen, and was later on contracted by the news magazine LIFE. He traveled the world for many years covering mainly conflict areas, for example Rwanda during the genocide in 1994 and the conflicts in former Yugoslavia, Sudan, Somalia and Angola etc.</p>
            <p>Early 2000 he established his own company, Studio Jens Assur. The first major project was <i>Under the Shifting Skies</i>, where he portraited the increasing number of people alienated from the Swedish society. For example, asylum seekers, members of Hells Angels, neo Nazis, immigrants etc. The project resulted in two large books and an exhibition that traveled the art galleries and museums.</p>
            <p>Mid 2000 Assur turned the camera towards himself, his own socioeconomic group and the close by surroundings. The project was called <i>This is My Time, This is My Life</i> and opened at the Museum of Modern Art in Stockholm. For this project the classic polaroid images were used in order to avoid any kind of editing and create absolute authenticity.</p>
            <p>This exhibition was followed up by <i>Hunger</i>, an international project where Assur turned the focus on global migration, energy consumption and climate issues. He changed his artistic language and started to work with a large format camera, the Ebony, 5x7. The reason for this was to illustrate the big structures of society. The aim was also to make the spectator 1 to 1 with the artwork and therefore the images were printed in 2x3 meters. The project resulted in five different books, sent to 1000 of the most influential people in Sweden. The books and a large exhibition at Kulturhuset made a great buzz in media and created a political movement in the Swedish society.</p>
            <p>2013 Assur launched his most ambitious photographic project, <i>Africa Is a Great Country</i>. By using the large format camera, he continued the <i>Hunger</i>-journey but turned solely towards the African continent. The objective was to give another picture of Africa, a picture that differed from the two most common ones: an Africa suffering from HIV, conflicts, starvation and the picturesque Africa with wildlife and animals. Instead, he wanted to show on the development of the big African economies, the growing middleclass and the urban life. The exhibition opened at the prominent art museum, Liljevalchs in Stockholm (one of the largest in Europe) but also created international acclaim in world media.</p> 
            <p>Jens Assur has also written, directed and produced five feature films, which have all been selected to the world’s leading film festivals. Drawing from his experiences as a war photographer, his debut short film The Last Dog in Rwanda won numerous international awards including the Grand Prix at Clermont-Ferrand and Best Film at Tribeca Film festival, as well as prizes in Palm Springs, Nashville, and Rome among others. Assur pushed the envelope further with three more shorts, Killing the Chickens to Scare the Monkeys, A Society, and Hot Nasty Teen.</p>
            <p>His debut feature film, Ravens premiered in October 2017 at the Toronto International Film Festival. It has since then been acknowledged and embraced by critics and audiences while continuing on the international film circuit, in San Sebastián, Busan, London, Rome, Rotterdam, San Francisco, Tbilisi and other cities.</p>
            <p>At the moment Assur is working on a new exciting photographic project, that will be launched as a solo exhibition at the art museum Liljevalchs in 2023. <i>The Untitled Project</i> is an investigation of the relation between human nature and the great unknown. It will be a unique exploration of an outdoor lifestyle, never seen before. It is a global project that will travel the national as well as the international art scene.</p>
            <ObserverBottom title="Biography" setIsCurrent={setIsCurrent} />
          </div>
        </Section>

        <Section className="contact" id="contact" ref={setRef('contact')}>
            <ObserverTop title="Contact" setIsCurrent={setIsCurrent} />
            <h2>Contact</h2>
            <p>
              <i>Office</i><br/>
              Studio Jens Assur<br/>
              Karolinervägen 80<br/>
              837 71 Duved, Sweden<br/><br/>

              <i>Stockholm Office</i><br/>
              Studio Jens Assur<br/>
              Eastmansvägen 12<br/>
              113 61 Stockholm<br/><br/>
              <a href="tel:+46708111145">+46 (0) 708 11 11 45</a><br/>
              <a href="mailto:info@assur.se">info@assur.se</a>
            </p>

            <p>
              <i>For Art inquiries</i><br/>
              <a href="tel:+46707483672">+46 (0) 707 48 36 72</a><br/>
              <a href="mailto:jennie@assur.se">jennie@assur.se</a>
            </p>

            <p>
              <i>Social media</i><br/>
              <a href="https://www.instagram.com/jensassur">Instagram</a>
            </p>

            <Credits>
              <div>
                Design by <a href="https://www.parasol-projects.com/">Parasol</a><br/>
                Code by <a href="https://www.persturesson.com/">Per Sturesson</a>
              </div>
            </Credits>
            {/* <ObserverBottom title="Contact" setIsCurrent={setIsCurrent} /> */}
        </Section>
      </PageWrap>
    </>
  )
}

export default AboutPage